export const TransaltionLanguages= [
    "EN",
    "DE",
    "FR",
    "IT",
    "ES",
    "PT"
] as const

export type TransaltionLanguageType = typeof TransaltionLanguages[number];